const cn = {
    base: 'border-solid border-2 h-6 w-6',
    large: 'border-solid border-4 h-10 w-10',
    small: 'border-solid border h-4 w-4',
    custom: '',
}

interface SpinnerProps {
    variant?: keyof typeof cn
    className?: string
}

export const Spinner = ({ className = '', variant = 'base' }: SpinnerProps) => (
    <div
        className={`loader animate-spin rounded-full ${cn[variant]} ${className}`}
    />
)
